<template lang="pug">

  //- COMPONENT TEMPLATE
  ul.noticias-lista(v-if="noticias.length")
    li.noticia-item.clearfix(v-for="noticia of noticias")
      figure.imagem
        img(:src="noticia.cover", :title="noticia.titulo")
      .detalhe
        router-link.titulo(:to="{ name: 'Noticia', params: { id: noticia.id } }"): titulo.-withbar {{ noticia.titulo }}
        span.data {{ noticia.data_publicacao }}
        tags(v-if="noticia.tags", :itens="noticia.tags")

  //- LOADING TEMPLATE
  .loading-container.noticia-loading(v-else)
    span.sr-only Carregando...
    each val in [1, 2, 3]
      .item
        .slot: .cover.animated
        .slot
          .texto
            .titulo.animated
            .data.animated
            .div(style="display:block")
              .tag.animated
              .tag.animated
              .tag.animated

</template>

<style lang="scss">
  // Style
  .noticias-lista {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .noticia-item {
    margin-bottom: 20px;
    width: 100%;

    &:last-child { margin-bottom: 0; }

    > .imagem {
      width: 100%;
      height: 0;
      padding-bottom: 50%;
      margin-bottom: 15px;
      border-radius: 5px;
      @extend %imagem_proporcional;
      img { border-radius: 5px; }
    }

    > .detalhe {
      width: 100%;
      > .titulo > h3 { width: 100%; }
      > .titulo > h3:hover { color: $color-blue-light }
      > .data { position: relative; width: 100px; }
      > .tags { width: 100%; }
    }

    .tag {
      margin: 5px 5px 5px 0;
      margin-bottom: 10px;
      padding: 3px 9px;
      border-radius: 5px;
      float: left;

      &.first {
        background-color: $color-blue-dark;
        color: $color-neutral !important;
      }

      &:not(.first) {
        text-transform: lowercase;
        background-color: $color-green-light;
      }

      &:not(.first):hover {
        background-color: $color-green-dark !important;
        color: $color-neutral !important;
      }
    }

    @include media(">=tablet") {
      > .imagem {
        width: 250px;
        height: 130px;
        padding: 0;
        margin-right: 30px;
        float: left;
      }

      > .detalhe {
        padding-left: 280px;
      }
    }

    @include media(">=desktop") {
      .tag { padding: 1px 9px }
    }
  }
</style>

<script>
  import SubTitulo from 'COMPONENTS/ElementTitle'
  import Tags from 'COMPONENTS/Tags'
  import Titulo from 'COMPONENTS/ContentTitle'

  export default {
    name: 'noticias',

    props: {
      noticias: { type: Array, required: true }
    },

    components: {
      SubTitulo,
      Tags,
      Titulo
    }
  }
</script>



// WEBPACK FOOTER //
// NoticiasLista.vue?1c56c5d0